const parse = ( apiError ) => {
  switch ( apiError.data?.error ) {
    case 'password-too-short':
      return 'Whoops! Looks like your password is too short. It should be at least 6 characters long.';
    case 'exists':
      return 'Whoops! Looks like that email address is already associated with an account.';
    default:
      return "Whoops! Something went wrong and we can't create your account at this moment. Please try again later.";
  }
};

export default {
  parse,
};
